import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getDashboardData } from '../slice/contactUsSlice';
import { FaImages, FaBox, FaUsers } from 'react-icons/fa';
import { MdContacts } from 'react-icons/md';
import { RiOrderPlayLine } from 'react-icons/ri';
import MonthSalesChart from 'common/chart/MonthSalesChart';

function Home() {
  const dispatch = useDispatch();
  const Data = useSelector((state) => state.contactus);

  const salesDataINR = [
    1250000, 1575000, 2310000, 1980000, 2740000, 3200000,
    3450000, 3100000, 2900000, 3600000, 4100000, 5050000
  ];

  const { table_counts } = Data.data;
  useEffect(() => {
    dispatch(getDashboardData());
  }, [dispatch]);

  const stats = [
    { label: 'Total Banner', count: table_counts?.banner, icon: <FaImages size={22} />, color: 'bg-warning' },
    { label: 'Total Product', count: table_counts?.product, icon: <FaBox size={22} />, color: 'bg-primary' },
    { label: 'Total Orders', count: table_counts?.order, icon: <RiOrderPlayLine size={22} />, color: 'bg-success' },
    { label: 'Total Users', count: table_counts?.customer, icon: <FaUsers size={22} />, color: 'bg-info' },
    { label: 'Contact Us', count: table_counts?.contactus, icon: <MdContacts size={22} />, color: 'bg-danger' }
  ];

  return (
    <div className="container-fluid px-lg-5 mt-4">
      <div className="mainheadig">
        <h1>Dashboard</h1>
        <span className="text-white-50" style={{ fontSize: 13 }}>Admin Overview</span>
      </div>

      <div className="stat-row">
        {stats.map((stat, index) => (
          <div className="stat-col" key={index}>
            <div className="stat-card">
              <div className="stat-header">
                <div className={`icon-square ${stat.color} text-white`}>
                  {stat.icon}
                </div>
                <div className="stat-content">
                  <div className="stat-label">{stat.label}</div>
                  <div className="stat-count">{stat.count ?? 0}</div>
                </div>
              </div>
              <div className="stat-footer">Overall statistics</div>
            </div>
          </div>
        ))}
      </div>

      <div className="card mt-4 p-4">
        <h3 className="heading-sales">Sales Overview</h3>
        <MonthSalesChart
          title="Month-wise Sales (INR)"
          data={salesDataINR}
          type="column"
          height={440}
        />
      </div>
    </div>
  );
}

export default Home;
